"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type ResetSituationsConfigsRequest } from "@/generated/fastapi";
import { resetSituationsConfigs } from "../api/resetSituationsConfigs";
import { situationsKeys } from "../queries/keys";

export default function useResetSituationsConfigsMutation() {
  const queryClient = useQueryClient();
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: (request: ResetSituationsConfigsRequest) =>
      resetSituationsConfigs(accessToken, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: situationsKeys.all });
    },
  });
}
